<template>
  <div id="addGoodsPurchase">
    <div class="invoicingHead" style="height:40px;">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicingFather/goodsPurchase')" href="javascript:;">进货单管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>新增进货单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="invoicingHeadDown">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="业务日期">
            <el-date-picker v-model="form.dataTime" :clearable="false" type="datetime" placeholder="选择业务日期" @change="dataTimeChoose" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
          </el-form-item>
            <!-- <el-form-item label="经手人">
              <el-select size="small" v-model="form.shopWorkerUserId" placeholder="经手人" @change="shopWorkerUserIdChange">
                <el-option v-for="item in handlerList" :key="item.shopWorkerUserId" :label="item.fullName" :value="item.shopWorkerUserId"></el-option>
            </el-select>
            </el-form-item> -->
          <el-form-item label="供应商">
              <el-select size="small" v-model="form.supplierId" placeholder="供应商" @change="supplierIdChange">
                  <el-option v-for="item in supplierList" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="入库仓库">
              <el-select size="small" v-model="form.repositoryId" placeholder="入库仓库" @change="repositoryIdChange">
                  <el-option v-for="item in repositoryGoodsList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="submitForm('form')">选择商品</el-button>
          </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { Shop_handlerList, supplierList, repositoryList, defaultParam } from "../api";
export default {
  data() {
    return {
      form: {
        dataTime: "",
        shopWorkerUserId: "",
        repositoryId: "",
        supplierId: "",
        shopStoreId: ""
      },
      handlerList: [],
      repositoryGoodsList: [],
      supplierList: [],
      value: false,
      shopWorkersList: [],
      userList: [],
      shopInformation: []
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    
    this.Shop_handlerList();
  },
  methods: {
    // 获取默认参数
    getDefaultParam() {
      defaultParam({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999
      })
      .then(res => {
        if (res.code == 1) {
          this.form.dataTime = res.data.repository.modifyTime
          this.form.shopWorkerUserId = res.data.handler.shopWorkerUserId
          this.form.supplierId = res.data.supplier.supplierId
          this.form.repositoryId = res.data.repository.repositoryId
          this.form.shopStoreId = res.data.repository.shopStoreId
          localStorage.setItem("checkSupplierId", this.form.supplierId)
          localStorage.setItem("checkShopStoreId", this.form.shopStoreId)
          localStorage.setItem("checkShopWorkerUserId", this.form.shopWorkerUserId)
          localStorage.setItem("checkRepositoryId", this.form.repositoryId)
          localStorage.setItem("repositoryInId", this.form.repositoryId)
          var index = this.repositoryGoodsList.findIndex(item => {
            return item.repositoryId == this.form.repositoryId
          })
          if (index !== -1) {
              localStorage.setItem("repositoryInName", this.repositoryGoodsList[index].repositoryName)
          }
        }
      })
    },
    // 选择业务日期
    dataTimeChoose() {
      console.log(this.form.dataTime)
    },
    // 经手人列表
    Shop_handlerList() {
      Shop_handlerList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999
      })
      .then(res => {
        if (res.code == 1) {
          this.handlerList = res.data[0].workers
          this.getSupplierList()
        }
      })
    },
    // 获取供应商列表
    getSupplierList() {
      supplierList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999
      })
      .then(res => {
        if (res.code == 1) {
          this.supplierList = res.data
          this.repositoryGoodsDetailList()
        }
      })
    },
    // 获取仓库列表
    repositoryGoodsDetailList() {
      repositoryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999
      })
      .then(res => {
        if (res.code == 1) {
          this.repositoryGoodsList = res.data
          this.getDefaultParam();
        }   
      })
    },
    shopWorkerUserIdChange(val) {
      localStorage.setItem("checkShopWorkerUserId", val)
    },
    supplierIdChange(val) {
      localStorage.setItem("checkSupplierId", val)
    },
    repositoryIdChange(val) {
      var index = this.repositoryGoodsList.findIndex(item => {
        return val == item.repositoryId
      })
      if (index !== -1) {
        localStorage.setItem("repositoryInId", val)
        localStorage.setItem("checkShopStoreId", this.repositoryGoodsList[index].shopStoreId)
        localStorage.setItem("repositoryInName", this.repositoryGoodsList[index].repositoryName)
      }
      
    },
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    submitForm() {
      if (this.form.dataTime == null) {
        this.$message.error("请选择业务日期")
        return
      }
      localStorage.setItem("goodsStyle", 1)
      localStorage.setItem("dataTime", this.form.dataTime)
      this.$router.push({ path: '/invoicingFather/chooseGoods', query: { goodsStyle: localStorage.getItem("goodsStyle") }})
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/addGoodsPurchase.vue